import React, { useState } from 'react';

function UserDetailsForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        legalStatus: '',
        difficulties: '',
    });

    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Submitting form data:', formData); // 👈 Debug line

        try {
            await fetch('https://script.google.com/macros/s/AKfycbzeib2JFesoHlv-WUb0r-te4_YgJ0xKsBmPrt0NlreqS-lsjLiQy0unC4LELWJANwKb/exec', {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            setSubmitted(true);
            handleClear();
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Something went wrong. Please try again.');
        }
    };

    const handleClear = () => {
        setFormData({
            name: '',
            email: '',
            phone: '',
            legalStatus: '',
            difficulties: '',
        });
    };

    return (
        <section className="user-details-form" id="user-details">
            {!submitted ? (
                <>
                    <h2>Request Assistance</h2>
                    <p>
                        Fill out the form below to get expert help with your <span className="osap-highlight">OSAP</span> application.
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Name:</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email:</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">Phone:</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Legal Status:</label>
                            <div className="radio-group">
                                {[
                                    'Canadian Citizen',
                                    'Permanent Resident',
                                    'International Student',
                                    'Protected Person / Convention Refugee',
                                ].map((status) => (
                                    <label className="radio-label" key={status}>
                                        <input
                                            type="radio"
                                            name="legalStatus"
                                            value={status}
                                            checked={formData.legalStatus === status}
                                            onChange={handleChange}
                                            required
                                        />
                                        {status}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="difficulties">Tell us about your difficulties:</label>
                            <textarea
                                id="difficulties"
                                name="difficulties"
                                value={formData.difficulties}
                                onChange={handleChange}
                                rows="4"
                                placeholder="What challenges are you facing?"
                                required
                            ></textarea>
                        </div>

                        <div className="form-buttons">
                            <button type="submit" className="form-submit-button">Submit</button>
                            <button type="button" className="form-clear-button" onClick={handleClear}>Clear</button>
                        </div>
                    </form>
                </>
            ) : (
                <div className="thank-you-popup">
                    <h3>Thank you!</h3>
                    <p>Your form was submitted successfully. We’ll get back to you soon.</p>
                </div>
            )}
        </section>
    );
}

export default UserDetailsForm;
